import { DATE_SEP } from "@/components/PDFPreviews";

/**
 * Date formatting for the UI, fixed to the Indian convention.
 *
 * `toLocaleDateString()` with no locale follows the *browser's* locale, so the same case showed
 * 8/11/2026 to one person and 11/8/2026 to another — and on a US-locale machine every date read
 * month-first, which is the wrong way round for a Tamil Nadu legal service. These helpers pin the
 * order so what is on screen matches what is printed on the document.
 *
 * `DATE_SEP` is shared with the document renderer (PDFPreviews / core.templates_data), so the
 * separator is decided in exactly one place across the whole app.
 */
const pad = (n) => String(n).padStart(2, "0");

/** DD-MM-YYYY. Accepts a Date, an ISO string, or anything `new Date()` understands. */
export const fmtDate = (v) => {
  const d = v instanceof Date ? v : new Date(v);
  if (Number.isNaN(d.getTime())) return "";
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join(DATE_SEP);
};

/** 24-hour HH:MM — unambiguous, and narrower than "11:20 PM" in a fixed table column. */
export const fmtTime = (v) => {
  const d = v instanceof Date ? v : new Date(v);
  if (Number.isNaN(d.getTime())) return "";
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const fmtDateTime = (v) => {
  const d = fmtDate(v);
  return d ? `${d} ${fmtTime(v)}` : "";
};
